import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Badge,
  Menu,
  MenuItem,
  Fab,
} from "@material-ui/core";
import {
  Menu as MenuIcon,
  Person as AccountIcon,
  Send as SendIcon,
  ArrowBack as ArrowBackIcon,
  Notifications as NotificationsIcon,
} from "@material-ui/icons";
import classNames from "classnames";
import Cookies from 'universal-cookie';
import { useHistory } from 'react-router-dom';

// styles
import useStyles from "./styles";

// components
import { Typography } from "../Wrappers/Wrappers";
import Notification from "../Notification/Notification";
import UserAvatar from "../UserAvatar/UserAvatar";

// context
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
} from "../../context/LayoutContext";
import { useUserDispatch, signOut } from "../../context/UserContext";
import Constants from "../../utils/consts";
import checkToken from "../../services/checkToken";

// apis reminders
import getReminders from "../../services/getReminders";
import emettiFattura from "../../services/emettiFattura";
import getPagamento from "../../services/getPagamento";
import payProvvigione from "../../services/payProvvigione";
import payInvestimento from "../../services/payInvestimento";
import payStipendi from "../../services/payStipendi";
import payF24 from "../../services/payF24";
import payFattura from "../../services/payFattura";
import viewOrder from "../../services/viewOrder";
import deleteReminder from "../../services/deleteReminder";
import MyModalPosponi from "../../widgets/MyModalPosponi";
import viewCliente from "../../services/viewCliente";

const messages = [
  {
    id: 0,
    variant: "warning",
    name: "Jane Hew",
    message: "Hey! How is it going?",
    time: "9:32",
  },
  {
    id: 1,
    variant: "success",
    name: "Lloyd Brown",
    message: "Check out my new Dashboard",
    time: "9:18",
  },
  {
    id: 2,
    variant: "primary",
    name: "Mark Winstein",
    message: "I want rearrange the appointment",
    time: "9:15",
  },
  {
    id: 3,
    variant: "secondary",
    name: "Liana Dutti",
    message: "Good news from sale department",
    time: "9:09",
  },
];

export default function Header(props) {
  var classes = useStyles();
  const history = useHistory();

  const cookies = new Cookies();
  let username = cookies.get('username', { path: '/' });

  // global
  var layoutState = useLayoutState();
  var layoutDispatch = useLayoutDispatch();
  var userDispatch = useUserDispatch();

  // local
  var [mailMenu, setMailMenu] = useState(null);
  var [notificationsMenu, setNotificationsMenu] = useState(null);
  var [profileMenu, setProfileMenu] = useState(null);
  var [reminders, setReminders] = useState([]);
  const [modal, setModal] = useState({ show: false, id: "" });

  const checkT = async () => {
    const cookies = new Cookies();
    let username = cookies.get('username', { path: '/' });
    let token = cookies.get('token', { path: '/' });

    let isAuthenticated = await checkToken(username, token);
    if (!isAuthenticated) {
      cookies.remove('token');
      cookies.remove('username');
      window.location.href = '/#/login';
    }

    let tipoUtente = cookies.get('userType');
    if ((props.amministrazione && tipoUtente !== "0") || (props.tecnico && tipoUtente !== "1") || (props.magazzino && tipoUtente !== "2") || (props.commerciale && tipoUtente !== "3") || (props.customerservice && tipoUtente !== "4")) {
      cookies.remove('token');
      cookies.remove('username');
      window.location.href = '/#/login';
    }
  }

  const loadReminders = async () => {
    let username = cookies.get('username', { path: '/' });
    let token = cookies.get('token', { path: '/' });
    let tipoUtente = cookies.get('userType', { path: '/' });

    let type = undefined;
    switch (tipoUtente) {
      case "0":
        type = "amministrazione";
        break;
      case "1":
        type = "tecnico";
        break;
      case "2":
        type = "magazzino";
        break;
      case "3":
        type = "commerciale";
        break;
      case "4":
        type = "service";
        break;
      default:
        type = null
        break;
    }

    if (type == null) {
      setReminders([]);
      return;
    }

    let reminders = await getReminders(username, token, type);
    setReminders(reminders);
  }

  const getRemindersF = async () => {
    await loadReminders();
  }

  const reminderAction = async (reminder) => {
    let username = cookies.get('username', { path: '/' });
    let token = cookies.get('token', { path: '/' });
    var res = undefined;

    let type = undefined;
    let tipoUtente = cookies.get('userType');
    switch (tipoUtente) {
      case "0":
        type = '/#/app/ordini/';
        break;
      case "1":
        type = '/#/tecnico/ordini/';
        break;
      case "2":
        type = '/#/magazzino/uscita-merci/';
        break;
      case "3":
        type = '/#/commerciale/ordini/';
        break;
      case "4":
        type = '/#/service/ordini/';
        break;
      default:
        type = null
        break;
    }

    switch (reminder.tipo) {
      case "commessa_fat":
        res = await emettiFattura(username, token, reminder.id);
        break;
      case "commessa_in":
        res = await getPagamento(username, token, reminder.id);
        break;
      case "commessa_prov":
        res = await payProvvigione(username, token, reminder.id);
        break;
      case "commessa_prov_s":
        res = await payProvvigione(username, token, reminder.id);
        break;
      case "investimnento":
        res = await payInvestimento(username, token, reminder.id)
        break;
      case "stipendi":
        res = await payStipendi(username, token, reminder.id);
        break;
      case "F24":
        res = await payF24(username, token, reminder.id);
        break;
      case "fattura":
        res = await payFattura(username, token, reminder.id);
        break;

      case "ordine":
        res = await viewOrder(username, token, reminder.id);
        await deleteReminder(username, token, reminder.id);
        cookies.set('ordine', reminder.id_tipo, { path: '/' });

        let path = type;
        path = path.split('/');
        path[3] = "edit-ordine";
        path = path.join('/');

        if (window.location.href.indexOf(path) !== -1) {
          window.location.reload();
        } else {
          window.location.href = path;
        }

        break;
        
        case 'notifica ordine':
          history.replace({
            pathname: '/magazzino/uscita-merci/',
            state: { id: reminder.id_tipo, show: true }
          });
          await deleteReminder(username, token, reminder.id);
          setReminders(reminders.filter(r => r.id !== reminder.id));
          break;

        case 'notifica ddt magazzino':
          history.replace({
            pathname: '/magazzino/edit-ddt/',
            state: { id: reminder.id_tipo, show: true }
          });
          await deleteReminder(username, token, reminder.id);
          setReminders(reminders.filter(r => r.id !== reminder.id));
          break;

          case 'notifica ddt service':
            history.replace({
              pathname: '/service/edit-ddt/',
              state: { id: reminder.id_tipo, show: true }
            });
            await deleteReminder(username, token, reminder.id);
            setReminders(reminders.filter(r => r.id !== reminder.id));
            break;

            case 'notifica ddt amministrazione':
              history.replace({
                pathname: '/app/edit-ddt/',
                state: { id: reminder.id_tipo, show: true }
              });
              await deleteReminder(username, token, reminder.id);
              setReminders(reminders.filter(r => r.id !== reminder.id));
              break;

        case "cliente":
          res = await viewCliente(username, token, reminder.id);
          await deleteReminder(username, token, reminder.id);
          cookies.set('cliente', reminder.id_tipo, { path: '/' });
          
          let pathCliente = type;
          pathCliente = pathCliente.split('/');
          pathCliente[3] = "edit-cliente";
          pathCliente = pathCliente.join('/');
          
          if (window.location.href.indexOf(pathCliente) !== -1) {
            window.location.reload();
          } else {
            window.location.href = pathCliente;
          }
        break;

        case "prodotto":
          cookies.set('prodotto', reminder.id_tipo, { path: '/' });
          history.replace({
            pathname: '/app/prodotti/',
            state: { show: true, id: reminder.id_tipo }
          });
          await deleteReminder(username, token, reminder.id);
          setReminders(reminders.filter(r => r.id !== reminder.id));
          break;

        case 'notifica ordine fornitore':
          res = await viewOrder(username, token, reminder.id);
          await deleteReminder(username, token, reminder.id);
          
          cookies.set('ordineFornitore', reminder.id_tipo, { path: '/' });

          let pathFornitore = type;
          pathFornitore = pathFornitore.split('/');
          pathFornitore[3] = "edit-ordine-fornitore";
          pathFornitore = pathFornitore.join('/');

          if (window.location.href.indexOf(pathFornitore) !== -1) {
            window.location.reload();
          } else {
            window.location.href = pathFornitore;
          }
          break;

        case 'notifica ordine fornitore magazzino':
          history.replace({
            pathname: '/magazzino/entrata-merci/',
            state: { id: reminder.id_tipo, show: true }
          });
          await deleteReminder(username, token, reminder.id);
          setReminders(reminders.filter(r => r.id !== reminder.id));
          break;

      default:
        break;
    }

    if (res && res.result === 'ok') {
      getRemindersF();
      setNotificationsMenu(null);
    }
  }

  const onReload = async () => {
    window.location.reload();
  }

  const posponi = async (reminder) => {
    setModal(reminder)
  }

  const close = () => {
    let modalPosponi = modal;
    modalPosponi.show = false;
    setModal({ ...modalPosponi });
  }

  useEffect(() => {
    getRemindersF();
    setInterval(() => {
      getRemindersF();
    },30000);
    checkT();
  }, [props]);

  return (
    <AppBar position="fixed" className={classes.appBar}>
      {
        modal.show && <MyModalPosponi modal={modal} title={"Personalizza la tua email"} onClose={close.bind(this)} onReload={onReload} />
      }
      <Toolbar className={classes.toolbar}>
        <IconButton
          color="inherit"
          onClick={() => toggleSidebar(layoutDispatch)}
          className={classNames(
            classes.headerMenuButton,
            classes.headerMenuButtonCollapse,
          )}
        >
          {layoutState.isSidebarOpened ? (
            <ArrowBackIcon
              classes={{
                root: classNames(
                  classes.headerIcon,
                  classes.headerIconCollapse,
                ),
              }}
            />
          ) : (
            <MenuIcon
              classes={{
                root: classNames(
                  classes.headerIcon,
                  classes.headerIconCollapse,
                ),
              }}
            />
          )}
        </IconButton>
        <Typography variant="h6" weight="medium" className={classes.logotype}>
          PROGETTO SISMA
        </Typography>
        <Typography variant="h6" weight="medium" className={classes.logotype} style={{ marginLeft: '20px' }}>
          {Constants.apisFolder.indexOf("test") !== -1 ? 'TEST' : ''}
        </Typography>
        <Typography variant="h6" weight="medium" className={classes.logotype} style={{ marginLeft: '20px' }}>
          {props.amministrazione ? "AMMINISTRAZIONE" : props.tecnico ? "REPARTO TECNICO" : props.magazzino ? "REPARTO MAGAZZINO" : props.commerciale ? "REPARTO COMMERCIALE" : "CUSTOMER SERVICE"}
        </Typography>
        <div className={classes.grow} />

        <IconButton
          aria-haspopup="true"
          color="inherit"
          className={classes.headerMenuButton}
          aria-controls="notifications-menu"
          onClick={e => setNotificationsMenu(e.currentTarget)}
        >
          <Badge badgeContent={reminders.length} color='secondary'>
            <NotificationsIcon classes={{ root: classes.headerIcon }} />
          </Badge>
        </IconButton>

        <IconButton
          aria-haspopup="true"
          color="inherit"
          className={classes.headerMenuButton}
          aria-controls="profile-menu"
          onClick={e => setProfileMenu(e.currentTarget)}
        >
          <AccountIcon classes={{ root: classes.headerIcon }} />
        </IconButton>

        <Menu
          id="mail-menu"
          open={Boolean(mailMenu)}
          anchorEl={mailMenu}
          onClose={() => setMailMenu(null)}
          MenuListProps={{ className: classes.headerMenuList }}
          className={classes.headerMenu}
          classes={{ paper: classes.profileMenu }}
          disableAutoFocusItem
        >
          <div className={classes.profileMenuUser}>
            <Typography variant="h4" weight="medium">
              New Messages
            </Typography>
            <Typography
              className={classes.profileMenuLink}
              component="a"
              color="secondary"
            >
              {messages.length} New Messages
            </Typography>
          </div>
          {messages.map(message => (
            <MenuItem key={message.id} className={classes.messageNotification}>
              <div className={classes.messageNotificationSide}>
                <UserAvatar color={message.variant} name={message.name} />
                <Typography size="sm" color="text" colorBrightness="secondary">
                  {message.time}
                </Typography>
              </div>
              <div
                className={classNames(
                  classes.messageNotificationSide,
                  classes.messageNotificationBodySide,
                )}
              >
                <Typography weight="medium" gutterBottom>
                  {message.name}
                </Typography>
                <Typography color="text" colorBrightness="secondary">
                  {message.message}
                </Typography>
              </div>
            </MenuItem>
          ))}
          <Fab
            variant="extended"
            color="primary"
            aria-label="Add"
            className={classes.sendMessageButton}
          >
            Send New Message
            <SendIcon className={classes.sendButtonIcon} />
          </Fab>
        </Menu>

        {/* DROP DOWN NOTIFICHE */}
        {reminders.length > 0 &&
          <Menu
            id="notifications-menu"
            open={Boolean(notificationsMenu)}
            anchorEl={notificationsMenu}
            onClose={() => setNotificationsMenu(null)}
            className={classes.headerMenu}
            disableAutoFocusItem
          >
            {
              reminders.map(notification => (
                <MenuItem
                  key={notification.id}
                  className={{ ...classes.headerMenuItem, width: '100%' }}
                >
                  <Notification {...notification} typographyVariant="inherit" onReminderDone={reminderAction.bind(this)} onPosponi={(reminder) => posponi(reminder)} />
                </MenuItem>
              ))
            }
          </Menu>
        }

        {/* DROP DOWN PROFILO */}
        <Menu
          id="profile-menu"
          open={Boolean(profileMenu)}
          anchorEl={profileMenu}
          onClose={() => setProfileMenu(null)}
          className={classes.headerMenu}
          classes={{ paper: classes.profileMenu }}
          disableAutoFocusItem
        >
          <div className={classes.profileMenuUser}>
            <Typography variant="h4" weight="medium">
              {username}
            </Typography>
            <Typography
              className={classes.profileMenuLink}
            >
            </Typography>
          </div>

          <MenuItem
            className={classNames(
              classes.headerMenuItem,
            )} onClick={() => {
              setProfileMenu(null)
              let tipoUtente = cookies.get('userType');
              let type = undefined;
              switch (tipoUtente) {
                case "0":
                  type = "app";
                  break;
                case "1":
                  type = "tecnico";
                  break;
                case "2":
                  type = "magazzino";
                  break;
                case "3":
                  type = "commerciale";
                  break;
                case "4":
                  type = "service";
                  break;
                default:
                  type = null
                  break;
              }

              window.location.href = `#/${type}/usersettings`
            }}
          >
            <AccountIcon className={classes.profileMenuIcon} /> Profilo
          </MenuItem>
          {false &&
            <MenuItem
              className={classNames(
                classes.profileMenuItem,
                classes.headerMenuItem,
              )}
            >

              <AccountIcon className={classes.profileMenuIcon} /> Tasks
            </MenuItem>
          }
          {false &&
            <MenuItem
              className={classNames(
                classes.profileMenuItem,
                classes.headerMenuItem,
              )}
            >
              <AccountIcon className={classes.profileMenuIcon} /> Messages
            </MenuItem>
          }
          <div className={classes.profileMenuUser}>
            <Typography
              className={classes.profileMenuLink}
              color="primary"
              onClick={() => signOut(userDispatch, props.history)}
            >
              Esci
            </Typography>
          </div>
        </Menu>
      </Toolbar>
    </AppBar>
  );
}
